// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';

// These values can't be migrated to tokens, because EChart is based on Canvas and these values are used in the canvas that doesn't work well with tokens.
// DO NOT MIGRATE THIS TO SPACING TOKENS
export const CHART_SPACE_LEFT = gridSize * 10;
export const CHART_SPACE_BOTTOM = gridSize * 7.5;
